import React from "react";

const SlidingSideBar = ({
  children,
  visible = false,
  title = "",
  showCloseButton = true,
  onClose,
}) => {
  const Header = () => {
    return (
      <>
        <div className="d-flex">
          <h5 className="flex-grow-1">{title}</h5>
          {showCloseButton && (
            <span className="close_button mr-2" onClick={onClose}>
              X
            </span>
          )}
        </div>
        <hr className="my-2" />
      </>
    );
  };

  return (
    <div
      id="bar-container"
      className={`${visible ? "bar-visible" : "bar-collapsed"}`}
      onClick={() => onClose()}
    >
      <div id="bar-content" onClick={(e) => e.stopPropagation()}>
        {(title || showCloseButton) && <Header />}
        <div id="bar-body">{children}</div>
      </div>
    </div>
  );
};

export default SlidingSideBar;
